module.exports = __webpack_public_path__ + "static/06-e89976afe136cbc87e6493193c0f6c17.jpg";